import { enqueueSnackbar, DownloadFile } from 'actions';

/*
 * ---------------------------------------------------------------------------
 * LIGACAO A API REAL
 * ---------------------------------------------------------------------------
 * O frontend esta ligado a API real (KPIsOverviewRequests -> endpoints
 * KPIsOverview/* do PortalEE.Api). Os pedidos simulados (KPIsOverviewDummyRequests)
 * ficam disponiveis apenas para desenvolvimento offline: para voltar a eles,
 * comenta o bloco de import de KPIsOverviewRequests e descomenta o de baixo.
 * ---------------------------------------------------------------------------
 */
import {
	GetMetadataRequest,
	GetSitesRequest,
	GetCellsRequest,
	GetKpiSeriesRequest,
	ExportKpiSeriesRequest
} from '../requests/KPIsOverviewRequests';

// import {
// 	GetMetadataRequest,
// 	GetSitesRequest,
// 	GetCellsRequest,
// 	GetKpiSeriesRequest,
// 	ExportKpiSeriesRequest
// } from '../requests/KPIsOverviewDummyRequests';

/*
 * Os nomes dos tipos de accao levam o prefixo 'KPIS_OVERVIEW/' porque no
 * portal ha dezenas de reducers com o literal 'SET_FORM_STATE'; sem prefixo,
 * um dispatch desta view alterava o estado de todas as outras.
 */
export const SET_FORM_STATE = 'KPIS_OVERVIEW/SET_FORM_STATE';
export const SET_METADATA = 'KPIS_OVERVIEW/SET_METADATA';
export const SET_SITES = 'KPIS_OVERVIEW/SET_SITES';
export const SET_CELLS = 'KPIS_OVERVIEW/SET_CELLS';
export const SET_SERIES = 'KPIS_OVERVIEW/SET_SERIES';
export const SET_LOADING = 'KPIS_OVERVIEW/SET_LOADING';
export const RESET_SERIES = 'KPIS_OVERVIEW/RESET_SERIES';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onSetMetadata = (metadata) => ({
	type: SET_METADATA,
	metadata
});

const onSetSites = (sites, sitesKey) => ({
	type: SET_SITES,
	sites,
	sitesKey
});

const onSetCells = (cells, cellsKey) => ({
	type: SET_CELLS,
	cells,
	cellsKey
});

const onSetSeries = (result) => ({
	type: SET_SERIES,
	result
});

const onSetLoading = (isLoading) => ({
	type: SET_LOADING,
	isLoading
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ResetSeries = () => (dispatch) => {
	dispatch({ type: RESET_SERIES });
};

export const GetMetadata = () => async (dispatch) => {
	await GetMetadataRequest().then(response => {
		dispatch(onSetMetadata(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetSites = (technology, granularity) => async (dispatch) => {
	await GetSitesRequest(technology, granularity).then(response => {
		dispatch(onSetSites(response.data, `${technology}|${granularity}`));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

/*
 * Lista de celulas dos sites escolhidos. Chamada no Apply, depois de haver
 * sites. A `cellsKey` (tecnologia|granularidade|sites ordenados) evita repetir
 * o pedido quando so mudaram filtros que nao afectam a lista de celulas.
 */
export const GetCells = (technology, granularity, siteIds) => async (dispatch) => {
	const cellsKey = `${technology}|${granularity}|${[...siteIds].sort().join(',')}`;

	await GetCellsRequest(technology, granularity, siteIds).then(response => {
		dispatch(onSetCells(response.data, cellsKey));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetKpiSeries = (values, userId) => async (dispatch) => {
	dispatch(onSetLoading(true));

	await GetKpiSeriesRequest(values, userId).then(response => {
		dispatch(onSetSeries(response.data));
		dispatch(onSetLoading(false));

		const warnings = response.data.warnings || [];
		warnings.forEach((message) => {
			dispatch(enqueueSnackbar({ message, options: { variant: 'warning' } }));
		});
	}).catch((error) => {
		dispatch(onSetLoading(false));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ExportKpiSeries = (values, userId) => async (dispatch) => {
	await ExportKpiSeriesRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
